import { useDocumentTitle } from '../branding';

/** Sets the browser tab title to '<title> | Vitals Portal' ('Vitals Portal' when no title). */
const MetaData = ({ title }) => {
    useDocumentTitle(title);
    return null;
};

export default MetaData
